import { Box, Checkbox, Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { CreditNoteForOutletNewJson } from "../../DynamicFormsJson/Transaction/creditNoteForOutletNew";
import swal from "sweetalert";
import {
    areYouSureMsg,
    noInternetMsg,
    pleaseSelectAtLeastOneOutletMsg,
    saveFailedMsg,
    saveWarningMsg,
    savemsg,
    serverMsg,
} from "../../config/messageconstant";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import OfferCard from "./OfferCard";

class OutletCreditNoteForOffer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOffers: [],
            selectedOutlets: {},
            apiData: {},
            expandedProductIndex: {},
        };
    }

    async componentDidMount() {
        const { showNotification } = this.props;
        if (!navigator.onLine) {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    onSubmitData = () => {
        const { showNotification } = this.props;

        if (Object.keys(this.state.selectedOutlets).length === 0) {
            showNotification({
                msg: pleaseSelectAtLeastOneOutletMsg,
                severity: "error",
            });
            return;
        }

        const finalPayload = this.buildOldSubmitJson();

        this.handlePopupSubmit(finalPayload);
    };

    handleOutletCheckboxChange = (offerIndex, outletIndex, outlet, offer) => {
        const key = `${offerIndex}_${outletIndex}`;

        this.setState((prevState) => {
            const newSelectedOutlets = { ...prevState.selectedOutlets };

            if (newSelectedOutlets[key]) {
                delete newSelectedOutlets[key];
            } else {
                newSelectedOutlets[key] = {
                    ...outlet,
                    offerId: offer.id,
                    offerName: offer.name,
                    offerDescription: offer.description,
                    offerFromDate: offer.fromDate,
                    offerToDate: offer.toDate,
                };
            }

            return { selectedOutlets: newSelectedOutlets };
        });
    };

    toggleProductRow = (offerIndex, outletIndex) => {
        const key = `${offerIndex}_${outletIndex}`;

        this.setState((prevState) => ({
            expandedProductIndex: {
                ...prevState.expandedProductIndex,
                [key]: !prevState.expandedProductIndex[key],
            },
        }));
    };

    getSelectedOutletsCountForOffer = (offerIndex, outlets) => {
        return outlets.filter((outlet, outletIndex) => {
            const key = `${offerIndex}_${outletIndex}`;
            return this.state.selectedOutlets[key];
        }).length;
    };

    handleSelectAllOutletsForOffer = (offerIndex, outlets, offer, selectAll) => {
        this.setState((prevState) => {
            const newSelectedOutlets = { ...prevState.selectedOutlets };

            outlets.forEach((outlet, outletIndex) => {
                const key = `${offerIndex}_${outletIndex}`;
                if (selectAll) {
                    newSelectedOutlets[key] = {
                        ...outlet,
                        offerId: offer.id,
                        offerName: offer.name,
                        offerDescription: offer.description,
                        offerFromDate: offer.fromDate,
                        offerToDate: offer.toDate,
                    };
                } else {
                    delete newSelectedOutlets[key];
                }
            });

            return { selectedOutlets: newSelectedOutlets };
        });
    };

    transformApiData = (apiData) => {
        const { flagToSave } = this.props;

        if (!apiData || !apiData.data || !Array.isArray(apiData.data)) {
            return apiData;
        }

        const offerListNew = apiData.data.map((offer) => {
            return {
                id: offer.offerDetail?.id,
                name: offer.offerDetail?.name || "-",
                description: offer.offerDetail?.discription || "-",
                fromDate: offer.offerDetail?.fromDate || "-",
                toDate: offer.offerDetail?.toDate || "-",
                ...offer,
                crnType: flagToSave,
                outlets: offer.applicableOutletList.map((outlet, index) => {
                    const totalTaxAmt =
                        Number(outlet.cgstAmt || 0) +
                        Number(outlet.sgstAmt || 0) +
                        Number(outlet.igstAmt || 0);
                    return {
                        index: index + 1,
                        outletName: outlet.firmName || "-",
                        beatName: outlet.beatName || "-",
                        billNo: outlet.billNo || "-",
                        billDate: outlet.billDate || "-",
                        totalSaleQty: outlet.totalSaleQty || 0,
                        taxableAmount: outlet.taxableAmt.toFixed(2),
                        totalTaxAmt: totalTaxAmt.toFixed(2),
                        totalAmount: outlet.totalAmt.toFixed(2),
                        outletId: outlet.outletId || "-",
                        items: outlet.itemList.map((item, itemIndex) => ({
                            index: itemIndex + 1,
                            itemName: item.name || "-",
                            hsnCode: item.hsnCode || "-",
                            qty: item.qty || 0,
                            taxableAmt: Number(item.texableAmt || 0).toFixed(2),
                            taxAmt: Number(
                                (item.cgstAmt || 0) + (item.sgstAmt || 0) + (item.igstAmt || 0)
                            ).toFixed(2),
                            totalAmt: Number(item.total || 0).toFixed(2),
                            productId: item.productId,
                        })),
                    };
                }),
            };
        });

        return { offerListNew };
    };

    handlePopupSubmit = (selectedOffers) => {

        const { showLoador, showNotification } = this.props;
        swal({
            title: areYouSureMsg,
            text: saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                if (navigator.onLine) {
                    showLoador({ loador: true });
                    await apiPost({
                        url:
                            endpoint.creditNoteOffer +
                            "/generate-credit-note-outlet-for-new-offers",
                        postBody: selectedOffers,
                    }).then(({ data, success }) => {
                        if (success) {
                            this.setState({ selectedOffers: [] });
                            showNotification({ msg: savemsg });
                            this.props.navigate(-1);
                        } else {
                            showNotification({ msg: saveFailedMsg, severity: "error" });
                        }
                        return success;
                    });
                    showLoador({ loador: false });
                } else {
                    showNotification({ msg: noInternetMsg, severity: "error" });
                }
            }
        });
    };

    handleSelectAllChange = (event) => {
        const isChecked = event.target.checked;

        this.setState((prevState) => {
            if (!isChecked) {
                return {
                    selectedOffers: [],
                    selectedOutlets: {},
                };
            }

            const allSelectedOutlets = {};

            prevState.apiData.offerListNew.forEach((offer, offerIndex) => {
                offer.outlets.forEach((outlet, outletIndex) => {
                    const key = `${offerIndex}_${outletIndex}`;
                    allSelectedOutlets[key] = {
                        ...outlet,
                        offerId: offer.id,
                        offerName: offer.name,
                        offerDescription: offer.description,
                        offerFromDate: offer.fromDate,
                        offerToDate: offer.toDate,
                    };
                });
            });

            return {
                selectedOffers: [...prevState.apiData.offerListNew],
                selectedOutlets: allSelectedOutlets,
            };
        });
    };

    onSearch = async (data) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });
            await apiPost({
                url:
                    endpoint.creditNoteOffer +
                    "/claim-for-offer-outlet-with-new-offers?fromDate=" +
                    data.fromDate +
                    "&toDate=" +
                    data.toDate,
            }).then(({ data, success }) => {
                if (success) {
                    const transformedData = this.transformApiData(data);
                    this.setState({ apiData: transformedData });
                } else {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    buildOldSubmitJson = () => {
        const { selectedOutlets, apiData } = this.state;
        const { flagToSave } = this.props;

        const offerMap = {};

        Object.values(selectedOutlets).forEach((outlet) => {
            const offerId = outlet.offerId;
            const fullOffer = apiData.offerListNew.find((o) => o.id === offerId);

            if (!offerMap[offerId]) {
                offerMap[offerId] = {
                    id: fullOffer.id,
                    name: fullOffer.name,
                    description: fullOffer.description,
                    fromDate: fullOffer.fromDate,
                    toDate: fullOffer.toDate,
                    crnType: String(flagToSave),
                    offerDetail: fullOffer.offerDetail,
                    applicableOutletList: [],
                    outlets: [],
                };
            }

            offerMap[offerId].outlets.push({
                index: outlet.index,
                outletName: outlet.outletName,
                beatName: outlet.beatName,
                billNo: outlet.billNo || "-",
                billDate: outlet.billDate || "-",
                totalSaleQty: outlet.totalSaleQty || 0,
                taxableAmount: outlet.taxableAmount,
                totalTaxAmt: outlet.totalTaxAmt,
                totalAmount: outlet.totalAmount,
                outletId: outlet.outletId,
                items: outlet.items.map((item) => ({
                    index: item.index,
                    itemName: item.itemName,
                    hsnCode: item.hsnCode,
                    qty: item.qty,
                    taxableAmt: item.taxableAmt,
                    taxAmt: item.taxAmt,
                    totalAmt: item.totalAmt,
                    productId: item.productId,
                })),
            });

            const matchedApplicableOutlet = fullOffer.applicableOutletList.find(
                (ao) => ao.outletId === outlet.outletId
            );

            if (matchedApplicableOutlet) {
                const alreadyAdded = offerMap[offerId].applicableOutletList.some(
                    (ao) => ao.outletId === matchedApplicableOutlet.outletId
                );

                if (!alreadyAdded) {
                    offerMap[offerId].applicableOutletList.push(matchedApplicableOutlet);
                }
            }
        });

        return Object.values(offerMap);
    };

    render() {
        const { apiData, selectedOffers, expandedProductIndex, selectedOutlets } = this.state;

        return (
            <>
                <br />
                <DynamicFormWithoutSave
                    showBackToList={false}
                    dynamicMasterData={{}}
                    showTitle={false}
                    screenTitle={""}
                    fieldMeta={CreditNoteForOutletNewJson.fieldMetaForOutletCreditNoteOffer}
                    showSaveNextBtn={false}
                    saveBtnText={"Search"}
                    onSave={this.onSearch}
                    showSaveBtnMain={false}
                    showSaveBtn={true}
                />

                {Object.keys(apiData).length !== 0 && (
                    <Paper
                        sx={{
                            marginTop: 3,
                            padding: 2,
                            border: "1px solid #ddd",
                            borderRadius: 2,
                            elevation: 3,
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <LandingScreenHeader
                                screenTitle="CRN From Offer (Outlet)"
                                showSearchBox={true}
                                showAddButton={false}
                            />

                            <Box display="flex" alignItems="center">
                                <TypographyCompo
                                    sx={{ fontSize: 16, fontWeight: "bold", marginRight: 1 }}
                                >
                                    Select All Offers
                                </TypographyCompo>
                                <Checkbox
                                    checked={
                                        selectedOffers.length ===
                                        (apiData?.offerListNew?.length || 0) &&
                                        apiData?.offerListNew?.length > 0
                                    }
                                    onChange={this.handleSelectAllChange}
                                />
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                overflowY: "auto",
                                maxHeight: "500px",
                                borderRadius: "10px",
                                "&::-webkit-scrollbar": { display: "none" },
                            }}
                        >
                            <Grid container alignItems="center">
                                <Grid item xs={12} md={12} sm={12}>
                                    {apiData?.offerListNew?.length > 0 ? (
                                        <>
                                            {apiData?.offerListNew?.map((dataRow, index) => (
                                                <OfferCard
                                                    key={index}
                                                    offer={dataRow}
                                                    offerIndex={index}
                                                    selectedOutlets={selectedOutlets}
                                                    expandedProductIndex={expandedProductIndex}
                                                    onOutletCheckboxChange={this.handleOutletCheckboxChange}
                                                    onToggleProductRow={this.toggleProductRow}
                                                    onSelectAllOutletsForOffer={
                                                        this.handleSelectAllOutletsForOffer
                                                    }
                                                    getSelectedOutletsCountForOffer={
                                                        this.getSelectedOutletsCountForOffer
                                                    }
                                                />
                                            ))}
                                            <Grid
                                                item
                                                sm={12}
                                                xs={12}
                                                md={12}
                                                lg={12}
                                                container
                                                justifyContent="right"
                                                sx={{ padding: 1 }}
                                            >
                                                <ButtonCompo
                                                    size="medium"
                                                    type="Submit"
                                                    variant="contained"
                                                    name="Generate CRN"
                                                    onClick={this.onSubmitData}
                                                />
                                            </Grid>
                                        </>
                                    ) : (
                                        <TypographyCompo
                                            variant="h6"
                                            color="textSecondary"
                                            sx={{ textAlign: "center" }}
                                        >
                                            No offers available at the moment.
                                        </TypographyCompo>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { showLoador, showNotification };

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(OutletCreditNoteForOffer);